type PageUrlMapValue = string | RegExp;
type PageUrlsMap = Record<string, PageUrlMapValue>;

type PageLoadedSelectorsMap = Record<string, string[]>;
import { escapeBaseUrl } from '@e-comm-platform/web-otel-sdk';
import { getSnowplowUserData } from '@/utils/analytics/analytics-utils';
import { isPharmaprixBanner } from '@/utils';
import { SITE_ID } from '@/data/constants';

const pageUrlsMap: PageUrlsMap = {
  homepage: '/',
  // include only CLP
  browse_cat: /^\/(health|beauty|personal-care|home-electronics|electronics|baby-and-child)$/,
  browse_plp: /\/c\//,
};

const pageSelectorsMap: PageLoadedSelectorsMap = {
  homepage: ['[data-testid="masthead-main-bar"]', '.banner-container', '[data-testid="menu-tile-image"]'],
  browse_cat: ['.chakra-heading'],
  browse_plp: ['.chakra-checkbox', '[data-testid="checkbox"]', '.chakra-heading'],
};

let ignoredUrls = [
  new RegExp('https?:\\/\\/[^\\/]*cookielaw\\.org\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*fireworkapi1\\.com\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*pagead2\\.googlesyndication\\.com\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*mczbf\\.com\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*ct\\.pinterest\\.com\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*analytics\\.google\\.com\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*securepubads\\.g\\.doubleclick\\.net\\/.*'),
  new RegExp('https?:\\/\\/[^\\/]*fireworkadservices1\\.com\\/.*'),
]

let stepCsrOtelConfigs = {
  ignoredUrls: ignoredUrls,
  internalUrls: [escapeBaseUrl(process.env.NEXT_PUBLIC_BFF_URL)],
  externalUrls: [],
  pageUrlsMap: pageUrlsMap,
  pageSelectorsMap,
  getUserId: () => {
    return getSnowplowUserData().domainUserId;
  },
  getBannerId: () => {
    return isPharmaprixBanner() ? SITE_ID.PHX : SITE_ID.SDM;
  },
};

export { pageUrlsMap, pageSelectorsMap, stepCsrOtelConfigs };
